<template>
  <div>
    <div class="css-grid pay-invoice-form__row">
      <div class="h-collapsible"></div>
      <div>
        <div class="grid__col--12">
          <div class="form__item--row">
            <StoreConnectedInput :store="store" :action="action" name="paymentInfo" sub-prop="cardholderName" placeholder="Card Holder Name"></StoreConnectedInput>
          </div>
        </div>
      </div>
      <div class="h-collapsible"></div>
    </div>
    <div class="css-grid battery-order-form__row">
      <div class="h-collapsible"></div>
      <div>
        <div class="grid__col--7">
          <div class="form__item--row">
            <StoreConnectedInput :store="store" :action="action" name="paymentInfo" sub-prop="cardNumber" :debounce="false" placeholder="Credit Card Number"></StoreConnectedInput>
          </div>
        </div>
        <div class="grid__col--2--half">
          <div class="form__item--row">
            <StoreConnectedInput :store="store" :action="action" name="paymentInfo" sub-prop="expDate" :debounce="false" placeholder="MM/YY"></StoreConnectedInput>
          </div>
        </div>
        <div class="grid__col--2--half">
          <div class="form__item--row">
            <StoreConnectedInput :store="store" :action="action" name="paymentInfo" sub-prop="cvv" :debounce="false" placeholder="CVV"></StoreConnectedInput>
          </div>
        </div>
      </div>
      <div class="h-collapsible"></div>
    </div>
  </div>
</template>

<script>
  import StoreConnectedSelect from '../../form-items/StoreConnectedSelect.vue';
  import StoreConnectedInput from '../../form-items/StoreConnectedInput.vue'

  export default {
    name: 'CreditCardForm',
    components: {
      StoreConnectedInput,
      StoreConnectedSelect,
    },
    data() {
      return {
        store: 'payInvoice',
        action: 'setObjectProperty',
      };
    },
  };
</script>
